import React, { useEffect, useState } from "react";
import EditGuideToggle from "./EditGuideToggle";
import { useDispatch, useSelector } from "react-redux";
import AddGuide from "./AddGuide";
import AddGuideStepflow from "./AddGuideStepflow";

function AddGuideDashboard() {
  const Status = useSelector(
    (state) => state.statistics.EditGuideStatsToggleStatus
  );
  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Guide
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        <div className="flex font-Montserrat flex-wrap float-left ">
      <div className=" text-blue-200 py-4 font-medium "> Guide{`>`} Guide Name {` >`}</div>
      <div className="mt-4 mr-8 ml-2 text-gray-400 font-medium">
        Add
      </div>
    </div>
       
      
       
        <EditGuideToggle />
        {Status === "Info" ? <AddGuide /> : null}
        {Status === "Step Flow" ? <AddGuideStepflow /> : null}
      </div>
    </>
  );
}

export default AddGuideDashboard;
